import {
  CreateSopModulePayloadType,
  DeleteSingleSopDetailsPayloadType,
  GetSingleSopDetailsPayloadType,
  GetSopModulePayloadType,
  GetUniqueCheckSopDetailsPayloadType,
  HideSopPayloadType,
  UpdateSopModulePayloadType,
} from "../commonTypes/sopModuleTypes";
import { getCSRFToken, reverseDate } from "../utils/commonFunctions";
import { deleteData, getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";

export async function createSopModuleListApi(
  data: CreateSopModulePayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, fileData, fileName, uploads } = data;
  const finalData = {
    client_code: clientCode,
    file_data: fileData,
    file_name: fileName?.trim(),
    uploads,
  };
  return await postData(
    `invoice-generation/standard-operating-procedure/add`,
    { ...finalData },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
export async function getSopModuleListApi(
  data: GetSopModulePayloadType
): Promise<AxiosResponse> {
  const { token, searchValue, limit, offset, clientCode, filterStartDate, filterEndDate , type, userType} = data;

  let finalParams = {
    limit,
    offset,
    client_code: clientCode,
    type,
    user_type:userType,
    ...(searchValue && searchValue?.length > 0 && { search_term: searchValue }),
    ...(filterStartDate && filterStartDate?.length > 0 && { start_date: reverseDate(filterStartDate) }),
    ...(filterEndDate && filterEndDate?.length > 0 && { end_date: reverseDate(filterEndDate) }),
    
  };
  return await getData(`invoice-generation/standard-operating-procedure/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function getSingleSopDetailsApi(
  data: GetSingleSopDetailsPayloadType
): Promise<AxiosResponse> {
  const { token, sopId, clientCode, type } = data;

  let finalParams = {
    sop_id: sopId,
    client_code: clientCode,
    type
  };
  return await getData(
    `invoice-generation/standard-operating-procedure/details`,
    {
      params: {
        ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}
export async function getUniqueCheckSopFileNameApi(
  data: GetUniqueCheckSopDetailsPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, sopId, fileName, type ,role} = data;

  let finalParams = {
    sop_id: sopId,
    client_code: clientCode,
    file_name: fileName,
    type,
    role
  };
  return await getData(
    `invoice-generation/standard-operating-procedure/filename-unique-check`,
    {
      params: {
        ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}
export async function deleteSingleSopDetailsApi(
  data: DeleteSingleSopDetailsPayloadType
): Promise<AxiosResponse> {
  const { token, sopId, clientCode } = data;

  let finalParams = {
    sop_id: sopId,
    client_code: clientCode,
  };
  return await deleteData(
    `invoice-generation/standard-operating-procedure/delete`,
    {
      params: {
        ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateSopModuleApi(
  data: UpdateSopModulePayloadType
): Promise<AxiosResponse> {
  const { token, sopId, clientCode, fileData, fileName, uploads } = data;
  const finalData = {
    client_code: clientCode,
    file_data: fileData,
    file_name: fileName?.trim(),
    sop_id: sopId,
    uploads,
  };
  return await postData(
    `invoice-generation/standard-operating-procedure/update`,
    { ...finalData },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function hideUnhideSopApi(
  data: HideSopPayloadType
): Promise<AxiosResponse> {
  const {token, client_code,sop_id ,to_hide } = data;
  let finalData = {
    client_code,
      sop_id,
      to_hide
  };

  return await postData(`invoice-generation/standard-operating-procedure/hide`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    },
  });
}
